package com.imobly.imobly.api.dto

import kotlinx.serialization.Serializable

@Serializable
data class TokenDTO(val token: String = "")